export default "__VITE_ASSET__BXicmOYP__"